/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnSelectItemLink} from './adn-select.component';
import {OBJECT_TYPE} from '../../constants/object-type';

export function createObjectTypeItemLink(objectTypeKey: string): (item: any) => AdnSelectItemLink | null {
  const objectType = OBJECT_TYPE[objectTypeKey];

  return (item) => {
    if (!item?.id || !objectType?.stateName) {
      return null;
    }

    return {
      stateName: objectType.stateName,
      params: {id: item.id}
    };
  };
}
